/** @format */

interface WindowWithSW extends Window {
  swRegistration?: ServiceWorkerRegistration;
}

export const hasWaitingServiceWorker = (): boolean => {
  if (typeof window === "undefined") return false;
  return Boolean((window as unknown as WindowWithSW).swRegistration?.waiting);
};

export const getSwRegistration = (): ServiceWorkerRegistration | undefined => {
  if (typeof window === "undefined") return undefined;
  return (window as unknown as WindowWithSW).swRegistration;
};
